@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.date-picker {
  font-size: 0;
  display: inline-block;
  vertical-align: top;

  > input {
    border: 1px solid @date-picker--border-color;
    border-radius: 4px 0 0 4px;
    border-right: 0;
    height: 30px;
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    line-height: 30px;
    padding: 0 5px;
    width: 100px;
    box-sizing: border-box;

    &.full-width-input {
      width: calc(100% ~'-' 30px);
    }

    &.has-error {
      border-color: @input-v2-INTERNAL--error--border-color;
    }
  }
}

.date-picker-button-wrapper {
  font-size: 13px;
  display: inline-block;
  vertical-align: top;
  width: 30px;
}

.date-picker-button {
  width: 30px;
  border-radius: 0 4px 4px 0;

  &.has-error {
    border: 1px solid @input-v2-INTERNAL--error--border-color;
    border-left: 0;
  }
}

.icon-wrapper {
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.55);
  display: block;
  position: absolute;
}

.disabled {
  > input {
    color: @date-picker--disabled--text-color;
  }
}
